module.exports = __webpack_public_path__ + "static/media/alexallen.fae95846.jpeg";